import { zodResolver } from '@hookform/resolvers/zod';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { string, z } from 'zod';
import Button from '../atoms/Button';
import Checkbox from '../atoms/Checkbox';
import Dropdown from '../atoms/Dropdown';
import InputBox from '../atoms/InputBox';
import Text from '../atoms/Text';

const SignUp = ({
    isSelected,
    options,
    handleFormSubmit,
    errorMessage,
    isLoading,
    defaultEmail,
    ...property
}) => {
    const signUpSchema = z.object({
        name: string().min(5, { message: 'Please enter your Name' }),
        email: string()
            .min(1, { message: 'Please enter your Email ID' })
            .email('Please enter a valid Email ID to continue!'),
        companyName: string().optional(),
        companyWebsite: string().optional(),
        userType: z.object({
            label: string().optional(),
            value: string()
        }),
        agreedTerms: z.literal(true, {
            errorMap: () => ({ message: 'Please accept the terms' })
        })
    });
    const [user, setUser] = useState({
        companyName: '',
        name: '',
        email: defaultEmail,
        companyWebsite: '',
        userType: '',
        agreedTerms: false
    });
    const { register,watch, control, handleSubmit, formState } = useForm({
        defaultValues: { ...user },
        resolver: zodResolver(signUpSchema)
    });
    const { errors } = formState;
    return (
        <form
            onSubmit={handleSubmit(handleFormSubmit)}
            className={`flex flex-col space-y-6 mt-8 ${property.className}`}
        >
            {errorMessage.show && (
                <span className="text-red-500 text-center text-sm">
                    {errorMessage.message}
                </span>
            )}
            <InputBox
                type="text"
                placeholder="Full Name*"
                variant="Large"
                errorMessage={
                    errors.name ? errors.name.message : 'Full name is incorrect'
                }
                register={register}
                dbName="name"
                isError={!!errors.name}
            />

            <InputBox
                type="email"
                placeholder="Email*"
                variant="Large"
                errorMessage={
                    errors.email
                        ? errors.email.message
                        : '"Email ID is incorrect"'
                }
                register={register}
                dbName="email"
                isError={!!errors.email}
            />

            <InputBox
                type="text"
                placeholder="Company Name"
                variant="Large"
                register={register}
                dbName="companyName"
                isError={!!errors.companyName}
            />

            <InputBox
                type="text"
                placeholder="Company Website"
                variant="Large"
                register={register}
                dbName="companyWebsite"
                isError={!!errors.companyWebsite}
            />

            <Dropdown
                placeholder={'Choose an answer'}
                options={options}
                labelText="Choose the term that describes you best*"
                setUser={setUser}
                register={register}
                control={control}
                dbName={'userType'}
                errors={errors}
            />
            <div className="">
                <div className="flex space-x-2 items-center">
                    <Checkbox
                        register={register}
                        dbName="agreedTerms"
                        isError={!!errors.agreedTerms}
                        errors={errors}
                        name="agreedTerms"
                        isSelected={watch('agreedTerms')}
                    />
                    <Text
                        variant="body"
                        fontWeight="font-semibold"
                    >
                        I agree to the{' '}
                        <span className="text-primary-900">Terms</span> &
                        <span className="text-primary-900">
                            {' '}
                            Privacy Policy{' '}
                        </span>
                    </Text>
                </div>
                {!!errors.agreedTerms && (
                    <div className="block text-sm text-error-100 mt-1">
                        {errors.agreedTerms?.message || 'Error message'}
                    </div>
                )}
            </div>

            <Button
                label="Sign Up"
                size="medium"
                disabled={isLoading}
                type="submit"
            />

            <Button
                label="Sign In"
                size="medium"
                style="ghost"
                onClick={()=>{property.toggleSignUpAndSignIn(watch('email'))}}
            />
        </form>
    );
};

SignUp.propTypes = {
    className: PropTypes.string,
    options: PropTypes.array,
    errorMessage: PropTypes.object
};

export default SignUp;
